// ============================================
// Financial Service (Client-side)
//
// Calls financial Cloud Functions for generating
// and managing Stripe, QBO, and sync configurations.
// Follows the same auth pattern as orderService.ts.
// ============================================

import { CF_BASE_URL } from '../../config/api';

const BASE_URL = CF_BASE_URL;

function getVendorToken(): string {
  const token = sessionStorage.getItem('vendor_token');
  if (!token) throw new Error('Vendor not authenticated');
  return token;
}

// Generate financial configuration for a brand
export async function generateFinancialConfig(brandId: string): Promise<{
  success: boolean;
  stripeProducts: number;
  qboAccounts: number;
  syncRules: number;
}> {
  const token = getVendorToken();
  const res = await fetch(`${BASE_URL}/generateFinancialConfig`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ brandId }),
  });

  if (res.status === 401) {
    sessionStorage.removeItem('vendor_token');
    throw new Error('Vendor session expired');
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(err.error || 'Failed to generate financial config');
  }

  return res.json();
}
